// Self-contained pickup app. Rendered by the parent App when on the pickup
// subdomain. Owns its own BrowserRouter + Routes, wrapped in Suspense and the
// shared light layout. No em dashes anywhere - use " - ".

import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import PickupLayout from './components/PickupLayout'
import { Spinner } from './components/PickupUI'

const PickupHome = lazy(() => import('./pages/PickupHome'))
const PickupGroup = lazy(() => import('./pages/PickupGroup'))
const PickupRespond = lazy(() => import('./pages/PickupRespond'))
const PickupAdmin = lazy(() => import('./pages/PickupAdmin'))

export default function PickupApp() {
  return (
    <BrowserRouter>
      <PickupLayout>
        <Suspense fallback={<Spinner label="Loading" />}>
          <Routes>
            <Route path="/" element={<PickupHome />} />
            <Route path="/g/:slug" element={<PickupGroup />} />
            {/* /join/:slug is an alias for the group page (join form lives there). */}
            <Route path="/join/:slug" element={<PickupGroup />} />
            <Route path="/r/:token" element={<PickupRespond />} />
            <Route path="/admin" element={<PickupAdmin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </PickupLayout>
    </BrowserRouter>
  )
}
